import { isNil } from '@exodus/basic-utils';
import { Address, WalletAccount } from '@exodus/models';
import assert from 'minimalistic-assert';
import { AddressProvider } from './module.js';
export class MockableAddressProvider extends AddressProvider {
    #storage;
    constructor({ unsafeStorage, addressesCacheAtom, assetsModule, config, blockchainMetadata, }) {
        super({ addressesCacheAtom, assetsModule });
        this.#storage = unsafeStorage.namespace('debug');
        this.#ingestMocks(blockchainMetadata, config?.mockedAddresses);
    }
    #ingestMocks = async (blockchainMetadata, mocks) => {
        this.clearMocks();
        if (mocks) {
            for (const mock of mocks) {
                await this.mockAddress(mock);
            }
            await blockchainMetadata.clear();
        }
    };
    async #getMockAddress(params) {
        const key = this.#getMockKey(params);
        const mockAddresses = await this.#storage.get('mockableAddressProvider');
        return mockAddresses?.[key];
    }
    getAddress = async (opts) => {
        const mock = await this.#getMockAddress(opts);
        if (mock) {
            return Address.fromJSON(mock);
        }
        return super.getAddress(opts);
    };
    #getMockKey = ({ walletAccount = WalletAccount.DEFAULT_NAME, assetName, purpose, chainIndex = 0, addressIndex = 0, }) => {
        return `${walletAccount}:${assetName}:${purpose}:${chainIndex}:${addressIndex}`;
    };
    clearMocks = () => {
        this.#storage.clear();
    };
    mockAddress = async (params) => {
        const { walletAccount = WalletAccount.DEFAULT_NAME, assetName, address, purpose, chainIndex = 0, addressIndex = 0, } = params;
        assert(!isNil(walletAccount), `need to specify a walletAccount`);
        assert(!isNil(assetName), `need to specify an asset`);
        assert(!isNil(address), `need to specify an address`);
        assert(!isNil(purpose), `need to specify a purpose`);
        const existingMocks = await this.#storage.get('mockableAddressProvider');
        const key = this.#getMockKey(params);
        const mock = {
            address,
            meta: {
                purpose,
                path: `m/${chainIndex}/${addressIndex}`,
            },
        };
        const updatedMocks = { ...existingMocks, [key]: mock };
        this.#storage.set('mockableAddressProvider', updatedMocks);
    };
}
const mockableAddressProviderModuleDefinition = {
    id: 'mockableAddressProvider',
    type: 'module',
    factory: (args) => new MockableAddressProvider(args),
    public: true,
    dependencies: [
        'assetsModule',
        'addressesCacheAtom',
        'unsafeStorage',
        'config',
        'blockchainMetadata',
    ],
};
export default mockableAddressProviderModuleDefinition;
